import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./features/authReducer";
import MainReducer from "./features/mainReducer";

const store = configureStore({
  reducer: {
    auth: AuthReducer,
    Main: MainReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;